export class CollectionGallery extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.initializeGallery(this.els?.carousel)
  }

  initializeGallery(carousel) {
    if (typeof jQuery !== 'undefined' && carousel) {
      $(carousel.selector).owlCarousel({
        items: parseInt(carousel.element.dataset.items) || 1,
        startPosition: parseInt(carousel.element.dataset.startPosition) || 0,
        loop: carousel.element.dataset.loop === 'true',
        margin: 10,
        dots: carousel.element.dataset.dots === 'true',
      });
    } else {
      console.error('jQuery or OwlCarousel not loaded.', typeof jQuery, carousel);
    }
  }
}

customElements.define('collection-gallery', CollectionGallery)
